<template>
  <div>
    <!-- Hamburger menü butonu (sadece mobilde görünür) -->
    <button class="hamburger" @click="toggleSidebar">
      <i class="pi pi-bars"></i>
    </button>

    <!-- Overlay (sidebar açıkken arka planı karartır) -->
    <div v-if="isSidebarOpen" class="overlay" @click="toggleSidebar"></div>

    <!-- Sidebar -->
    <div class="sidebar" :class="{ open: isSidebarOpen }">
      <div class="sidebar-menu">
        <!-- Genel Menü -->
        <div class="menu-section">
          <div class="section-header">
            <i class="pi pi-home"></i>
            <span>Genel</span>
          </div>
          <router-link to="/" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-chart-line"></i>
            <span>Kontrol Paneli</span>
          </router-link>
        </div>

        <!-- Şifre Değiştirme Menüsü -->
        <div class="menu-section" v-if="canSeeChangePassword">
          <div class="section-header">
            <i class="pi pi-user"></i>
            <span>Hesabım</span>
          </div>
          <router-link to="/change-password" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-key"></i>
            <span>Şifre Değiştir</span>
          </router-link>
        </div>

        <!-- Yönetim Menüsü (Admin) -->
        <div class="menu-section" v-if="isAdmin">
          <div class="section-header">
            <i class="pi pi-cog"></i>
            <span>Yönetim</span>
          </div>
          <router-link to="/users" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-users"></i>
            <span>Personel</span>
          </router-link>
          <router-link to="/muhasebe" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-calculator"></i>
            <span>Muhasebe</span>
          </router-link>
 <router-link 
    v-if="canSeeFilesContracts" 
    to="/admin-files" 
    class="menu-item" 
    active-class="active" 
    @click="closeSidebar"
  >
    <i class="pi pi-box"></i>
    <span>Dosyalar & Sözleşmeler</span>
  </router-link>
 <router-link 
    v-if="canSeeFilesContracts" 
    to="/maas" 
    class="menu-item" 
    active-class="active" 
    @click="closeSidebar"
  >
    <i class="pi pi-money-bill"></i>
    <span>Maaş & Mesai</span>
  </router-link>
 <router-link 
    v-if="canSeeFilesContracts" 
    to="/organizasyon" 
    class="menu-item" 
    active-class="active" 
    @click="closeSidebar"
  >
    <i class="pi pi-briefcase"></i>
    <span>Organizasyonlar</span>
  </router-link>
          <router-link to="/vehicles" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-car"></i>
            <span>Araçlar</span>
          </router-link>
          <router-link to="/products" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-box"></i>
            <span>Ürünler</span>
          </router-link>
          <router-link to="/categories" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-tags"></i>
            <span>Ürün Kategorileri</span>
          </router-link>
        </div>

        <!-- Operasyon Menüsü -->
        <div class="menu-section">
          <div class="section-header">
            <i class="pi pi-briefcase"></i>
            <span>Operasyon</span>
          </div>
            <router-link 
    v-if="canSeeMesaiGiris"
    to="/mesaigiris" 
    class="menu-item" 
    active-class="active"
    @click="closeSidebar"
  >
    <i class="pi pi-clock"></i>
    <span>Mesai Giriş</span>
  </router-link>
          <!-- STOK TAKİP - GÜNCELLENDİ: Healthworker ve Driver da görebilir -->
          <router-link 
            v-if="isAdmin || isHealthWorker || isDriver"
            to="/stock" 
            class="menu-item" 
            active-class="active"
            @click="closeSidebar"
          >
            <i class="pi pi-inbox"></i>
            <span>Stok Takip</span>
          </router-link>
          
          <router-link to="/duties" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-calendar"></i>
            <span>Nöbetler</span>
          </router-link>

          <router-link to="/cases" class="menu-item" active-class="active" @click="closeSidebar">
            <i class="pi pi-file"></i>
            <span>Vakalar</span>
          </router-link>
          
          <!-- Sürücü Denetimleri -->
          <router-link 
            v-if="canSeeDriverInspections"
            to="/inspections" 
            class="menu-item" 
            active-class="active"
            @click="closeSidebar"
          >
            <i class="pi pi-check-circle"></i>
            <span>Sürücü Denetimleri</span>
          </router-link>

          <!-- Nöbet KM Güncelleme -->
          <router-link 
            v-if="canSeeDriverInspections"
            to="/nobet-km" 
            class="menu-item" 
            active-class="active"
            @click="closeSidebar"
          >
            <i class="pi pi-check-circle"></i>
            <span>Nöbet Aracı Km Güncelleme</span>
          </router-link>
          
          <!-- Tıbbi Demirbaş Denetimleri (Alt Menü) -->
          <div v-if="canSeeMedicalEquipment" class="submenu-section">
            <div class="submenu-header" @click="toggleSubmenu('medical')">
              <i class="pi pi-shield"></i>
              <span>Tıbbi Denetimler</span>
              <i class="pi pi-chevron-down submenu-arrow" :class="{ rotated: openSubmenus.medical }"></i>
            </div>
            <div class="submenu-items" :class="{ open: openSubmenus.medical }">
              <router-link to="/medical-equipment" class="menu-item submenu-item" active-class="active" @click="closeSidebar">
                <i class="pi pi-check"></i>
                <span>Tıbbi Demirbaş</span>
              </router-link>
              <router-link to="/ambulans-temizlik" class="menu-item submenu-item" active-class="active" @click="closeSidebar">
                <i class="pi pi-check"></i>
                <span>Vaka Arası Temizlik</span>
              </router-link>
              <router-link to="/temizlik-kontrol" class="menu-item submenu-item" active-class="active" @click="closeSidebar">
                <i class="pi pi-check"></i>
                <span>Ambulans Genel Temizlik</span>
              </router-link>
              <router-link to="/oksijen" class="menu-item submenu-item" active-class="active" @click="closeSidebar">
                <i class="pi pi-check"></i>
                <span>O2 Tüpü Takip</span>
              </router-link>
              <router-link to="/nem" class="menu-item submenu-item" active-class="active" @click="closeSidebar">
                <i class="pi pi-check"></i>
                <span>Isı ve Nem Takip</span>
              </router-link>
              <router-link to="/gluko-takip" class="menu-item submenu-item" active-class="active" @click="closeSidebar">
                <i class="pi pi-check"></i>
                <span>Glukometre Takip</span>
              </router-link>
              <router-link to="/sarj-takip" class="menu-item submenu-item" active-class="active" @click="closeSidebar">
                <i class="pi pi-check"></i>
                <span>Defibrilatör Şarj</span>
              </router-link>
              <router-link to="/narkotik" class="menu-item submenu-item" active-class="active" @click="closeSidebar">
                <i class="pi pi-check"></i>
                <span>Narkotik Takip</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, reactive, onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'Sidebar',
  setup() {
    const store = useStore();
    const userRole = computed(() => store.getters.userRole);
    const userName = computed(() => store.getters.userName);
    const userId = computed(() => store.getters.userId); // Kullanıcı ID'sini al


    const isAdmin = computed(() => userRole.value === 'admin');
    const isDriver = computed(() => userRole.value === 'driver');
    const isHealthWorker = computed(() => userRole.value === 'healthworker');

    const canSeeFilesContracts = computed(() => {
  return [149, 153, 1].includes(userId.value);
});


    const canSeeDriverInspections = computed(() => isAdmin.value || isDriver.value);
    const canSeeMesaiGiris = computed(() => { return isAdmin.value || isHealthWorker.value || isDriver.value;});
    const canSeeMedicalEquipment = computed(() => isAdmin.value || isHealthWorker.value);
    const canSeeChangePassword = computed(() => isDriver.value || isHealthWorker.value);

    const isSidebarOpen = ref(false);
    const openSubmenus = reactive({
      medical: false
    });

    // Masaüstünde tıbbi denetimler menüsü varsayılan olarak açık
    onMounted(() => {
      // Masaüstü görünümde tıbbi denetimler menüsünü açık tut
      if (window.innerWidth > 768) {
        openSubmenus.medical = true;
      }
    });

    const toggleSidebar = () => (isSidebarOpen.value = !isSidebarOpen.value);
    const closeSidebar = () => (isSidebarOpen.value = false);
    
    const toggleSubmenu = (submenu) => {
      openSubmenus[submenu] = !openSubmenus[submenu];
    };

    return {
      isAdmin,
      isDriver,
      isHealthWorker,
      userName,
      userId,
      canSeeFilesContracts, // Yeni computed property'yi döndür
      canSeeDriverInspections,
      canSeeMesaiGiris, // YENİ EKLE
      canSeeMedicalEquipment,
      canSeeChangePassword,
      isSidebarOpen,
      openSubmenus,
      toggleSidebar,
      closeSidebar,
      toggleSubmenu
    };
  }
};
</script>

<style scoped>
.sidebar {
  width: 280px;
  background: linear-gradient(180deg, #ffffff 0%, #fef2f2 100%);
  border-right: 1px solid #fecaca;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease-in-out;
  box-shadow: 2px 0 8px rgba(220, 38, 38, 0.1);
}

.sidebar-menu {
  flex: 1;
  padding: 1rem 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.menu-section {
  margin-bottom: 1rem;
  flex-shrink: 0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  color: #dc2626;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: rgba(220, 38, 38, 0.05);
  border-left: 3px solid #dc2626;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  color: #64748b;
  text-decoration: none;
  transition: all 0.2s;
  margin: 0.1rem 0.5rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.menu-item:hover {
  background-color: #fef2f2;
  color: #dc2626;
  transform: translateX(4px);
}

.menu-item.active {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.menu-item i {
  font-size: 1rem;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}

/* Alt Menü Stilleri - İyileştirilmiş */
.submenu-section {
  margin: 0.1rem 0;
  flex-shrink: 0;
}

.submenu-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
  margin: 0.1rem 0.5rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.submenu-header:hover {
  background-color: #fef2f2;
  color: #dc2626;
}

.submenu-arrow {
  margin-left: auto;
  transition: transform 0.3s ease;
  font-size: 0.8rem;
  flex-shrink: 0;
}

.submenu-arrow.rotated {
  transform: rotate(180deg);
}

.submenu-items {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.submenu-items.open {
  max-height: 1000px; /* Daha fazla alan için arttırıldı */
}

.submenu-item {
  padding-left: 2.5rem !important;
  font-size: 0.85rem !important;
  padding-top: 0.6rem !important;
  padding-bottom: 0.6rem !important;
  margin: 0.05rem 0.5rem !important;
}

.submenu-item i {
  font-size: 0.8rem !important;
}

/* Masaüstü için özel stiller */
@media (min-width: 769px) {
  .sidebar-menu {
    padding: 0.5rem 0;
  }
  
  .menu-section {
    margin-bottom: 0.8rem;
  }
  
  .menu-item {
    padding: 0.6rem 1.5rem;
    font-size: 0.85rem;
  }
  
  .section-header {
    padding: 0.6rem 1.5rem;
    font-size: 0.75rem;
  }
  
  .submenu-item {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  
  /* Masaüstünde scroll davranışı */
  .sidebar-menu {
    overflow-y: auto;
    max-height: calc(100vh - 2rem);
  }
}

/* Hamburger Menü */
.hamburger {
  display: none;
  position: fixed;
  top: 1rem;
  left: 1rem;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.6rem 0.8rem;
  z-index: 1100;
  cursor: pointer;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
  transition: all 0.2s;
}

.hamburger:hover {
  background: #b91c1c;
  transform: scale(1.05);
}

.hamburger i {
  font-size: 1.2rem;
}

.overlay {
  display: none;
}

/* Scrollbar Stili - İyileştirilmiş */
.sidebar-menu::-webkit-scrollbar {
  width: 6px;
}

.sidebar-menu::-webkit-scrollbar-track {
  background: #fef2f2;
  border-radius: 3px;
}

.sidebar-menu::-webkit-scrollbar-thumb {
  background: #fecaca;
  border-radius: 3px;
}

.sidebar-menu::-webkit-scrollbar-thumb:hover {
  background: #fca5a5;
}

/* Mobil için */
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    transform: translateX(-100%);
    z-index: 1000;
    box-shadow: 4px 0 15px rgba(0, 0, 0, 0.1);
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .hamburger {
    display: block;
  }
  
  /* Mobilde tıbbi denetimler kapalı başlasın */
  .submenu-items.open {
    max-height: 500px;
  }
}

/* Çok yüksek çözünürlükler için */
@media (min-height: 900px) {
  .sidebar-menu {
    padding: 1rem 0;
  }
  
  .menu-section {
    margin-bottom: 1.5rem;
  }
}

/* Düşük ekranlar için */
@media (max-height: 700px) {
  .sidebar-menu {
    padding: 0.3rem 0;
  }
  
  .menu-section {
    margin-bottom: 0.5rem;
  }
  
  .menu-item {
    padding: 0.5rem 1.5rem;
    font-size: 0.8rem;
  }
  
  .section-header {
    padding: 0.5rem 1.5rem;
    font-size: 0.7rem;
  }
  
  .submenu-item {
    padding-top: 0.4rem !important;
    padding-bottom: 0.4rem !important;
  }
}
</style>